/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Regenerate with `pnpm --filter @repo/api-client generate`, which reads the
 * OpenAPI document the API publishes at GET /v1/openapi.json.
 *
 * A hand-edit here fails `pnpm test`: the drift gate re-generates from the
 * checked-in openapi.json and compares byte for byte.
 */

import type {
  OperationBody,
  OperationDescriptor,
  OperationPath,
  OperationQuery,
  OperationResponse,
} from '../operation.ts';

export const AppController_getHello_v1 = {
  operationId: 'AppController_getHello_v1',
  method: 'get',
  path: '/v1',
  security: [],
} as const satisfies OperationDescriptor<'AppController_getHello_v1'>;
export type AppController_getHello_v1Response = OperationResponse<'AppController_getHello_v1'>;
export type AppController_getHello_v1Body = OperationBody<'AppController_getHello_v1'>;

export const HealthController_check_v1 = {
  operationId: 'HealthController_check_v1',
  method: 'get',
  path: '/v1/health',
  security: [],
} as const satisfies OperationDescriptor<'HealthController_check_v1'>;
export type HealthController_check_v1Response = OperationResponse<'HealthController_check_v1'>;
export type HealthController_check_v1Body = OperationBody<'HealthController_check_v1'>;

export const AuthController_signIn_v1 = {
  operationId: 'AuthController_signIn_v1',
  method: 'post',
  path: '/v1/auth/sign-in',
  security: [],
} as const satisfies OperationDescriptor<'AuthController_signIn_v1'>;
export type AuthController_signIn_v1Response = OperationResponse<'AuthController_signIn_v1'>;
export type AuthController_signIn_v1Body = OperationBody<'AuthController_signIn_v1'>;

export const AuthController_signOut_v1 = {
  operationId: 'AuthController_signOut_v1',
  method: 'post',
  path: '/v1/auth/sign-out',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'AuthController_signOut_v1'>;
export type AuthController_signOut_v1Response = OperationResponse<'AuthController_signOut_v1'>;
export type AuthController_signOut_v1Body = OperationBody<'AuthController_signOut_v1'>;

export const UsersController_list_v1 = {
  operationId: 'UsersController_list_v1',
  method: 'get',
  path: '/v1/users',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_list_v1'>;
export type UsersController_list_v1Response = OperationResponse<'UsersController_list_v1'>;
export type UsersController_list_v1Body = OperationBody<'UsersController_list_v1'>;
export type UsersController_list_v1Query = OperationQuery<'UsersController_list_v1'>;

export const UsersController_create_v1 = {
  operationId: 'UsersController_create_v1',
  method: 'post',
  path: '/v1/users',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_create_v1'>;
export type UsersController_create_v1Response = OperationResponse<'UsersController_create_v1'>;
export type UsersController_create_v1Body = OperationBody<'UsersController_create_v1'>;

export const UsersController_findOne_v1 = {
  operationId: 'UsersController_findOne_v1',
  method: 'get',
  path: '/v1/users/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_findOne_v1'>;
export type UsersController_findOne_v1Response = OperationResponse<'UsersController_findOne_v1'>;
export type UsersController_findOne_v1Body = OperationBody<'UsersController_findOne_v1'>;
export type UsersController_findOne_v1Path = OperationPath<'UsersController_findOne_v1'>;

export const UsersController_update_v1 = {
  operationId: 'UsersController_update_v1',
  method: 'patch',
  path: '/v1/users/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_update_v1'>;
export type UsersController_update_v1Response = OperationResponse<'UsersController_update_v1'>;
export type UsersController_update_v1Body = OperationBody<'UsersController_update_v1'>;
export type UsersController_update_v1Path = OperationPath<'UsersController_update_v1'>;

export const UsersController_deactivate_v1 = {
  operationId: 'UsersController_deactivate_v1',
  method: 'post',
  path: '/v1/users/{id}/deactivate',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_deactivate_v1'>;
export type UsersController_deactivate_v1Response =
  OperationResponse<'UsersController_deactivate_v1'>;
export type UsersController_deactivate_v1Body = OperationBody<'UsersController_deactivate_v1'>;
export type UsersController_deactivate_v1Path = OperationPath<'UsersController_deactivate_v1'>;

export const UsersController_reactivate_v1 = {
  operationId: 'UsersController_reactivate_v1',
  method: 'post',
  path: '/v1/users/{id}/reactivate',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_reactivate_v1'>;
export type UsersController_reactivate_v1Response =
  OperationResponse<'UsersController_reactivate_v1'>;
export type UsersController_reactivate_v1Body = OperationBody<'UsersController_reactivate_v1'>;
export type UsersController_reactivate_v1Path = OperationPath<'UsersController_reactivate_v1'>;

export const UsersController_clearLockout_v1 = {
  operationId: 'UsersController_clearLockout_v1',
  method: 'post',
  path: '/v1/users/{id}/clear-lockout',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_clearLockout_v1'>;
export type UsersController_clearLockout_v1Response =
  OperationResponse<'UsersController_clearLockout_v1'>;
export type UsersController_clearLockout_v1Body = OperationBody<'UsersController_clearLockout_v1'>;
export type UsersController_clearLockout_v1Path = OperationPath<'UsersController_clearLockout_v1'>;

export const UsersController_changeOwn_v1 = {
  operationId: 'UsersController_changeOwn_v1',
  method: 'post',
  path: '/v1/users/me/credential',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UsersController_changeOwn_v1'>;
export type UsersController_changeOwn_v1Response =
  OperationResponse<'UsersController_changeOwn_v1'>;
export type UsersController_changeOwn_v1Body = OperationBody<'UsersController_changeOwn_v1'>;

export const TerminalsController_list_v1 = {
  operationId: 'TerminalsController_list_v1',
  method: 'get',
  path: '/v1/terminals',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TerminalsController_list_v1'>;
export type TerminalsController_list_v1Response = OperationResponse<'TerminalsController_list_v1'>;
export type TerminalsController_list_v1Body = OperationBody<'TerminalsController_list_v1'>;
export type TerminalsController_list_v1Query = OperationQuery<'TerminalsController_list_v1'>;

export const TerminalsController_create_v1 = {
  operationId: 'TerminalsController_create_v1',
  method: 'post',
  path: '/v1/terminals',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TerminalsController_create_v1'>;
export type TerminalsController_create_v1Response =
  OperationResponse<'TerminalsController_create_v1'>;
export type TerminalsController_create_v1Body = OperationBody<'TerminalsController_create_v1'>;

export const TerminalsController_register_v1 = {
  operationId: 'TerminalsController_register_v1',
  method: 'post',
  path: '/v1/terminals/{id}/register',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TerminalsController_register_v1'>;
export type TerminalsController_register_v1Response =
  OperationResponse<'TerminalsController_register_v1'>;
export type TerminalsController_register_v1Body = OperationBody<'TerminalsController_register_v1'>;
export type TerminalsController_register_v1Path = OperationPath<'TerminalsController_register_v1'>;

export const TerminalsController_revoke_v1 = {
  operationId: 'TerminalsController_revoke_v1',
  method: 'post',
  path: '/v1/terminals/{id}/revoke',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TerminalsController_revoke_v1'>;
export type TerminalsController_revoke_v1Response =
  OperationResponse<'TerminalsController_revoke_v1'>;
export type TerminalsController_revoke_v1Body = OperationBody<'TerminalsController_revoke_v1'>;
export type TerminalsController_revoke_v1Path = OperationPath<'TerminalsController_revoke_v1'>;

export const TerminalSelfController_renewLease_v1 = {
  operationId: 'TerminalSelfController_renewLease_v1',
  method: 'post',
  path: '/v1/terminals/me/lease',
  security: [{ terminalLease: [] }],
} as const satisfies OperationDescriptor<'TerminalSelfController_renewLease_v1'>;
export type TerminalSelfController_renewLease_v1Response =
  OperationResponse<'TerminalSelfController_renewLease_v1'>;
export type TerminalSelfController_renewLease_v1Body =
  OperationBody<'TerminalSelfController_renewLease_v1'>;

export const TerminalSelfController_fetchRoster_v1 = {
  operationId: 'TerminalSelfController_fetchRoster_v1',
  method: 'get',
  path: '/v1/terminals/me/roster',
  security: [{ terminalLease: [] }],
} as const satisfies OperationDescriptor<'TerminalSelfController_fetchRoster_v1'>;
export type TerminalSelfController_fetchRoster_v1Response =
  OperationResponse<'TerminalSelfController_fetchRoster_v1'>;
export type TerminalSelfController_fetchRoster_v1Body =
  OperationBody<'TerminalSelfController_fetchRoster_v1'>;

export const TerminalSelfController_fetchCatalogue_v1 = {
  operationId: 'TerminalSelfController_fetchCatalogue_v1',
  method: 'get',
  path: '/v1/terminals/me/catalogue',
  security: [{ terminalLease: [] }],
} as const satisfies OperationDescriptor<'TerminalSelfController_fetchCatalogue_v1'>;
export type TerminalSelfController_fetchCatalogue_v1Response =
  OperationResponse<'TerminalSelfController_fetchCatalogue_v1'>;
export type TerminalSelfController_fetchCatalogue_v1Body =
  OperationBody<'TerminalSelfController_fetchCatalogue_v1'>;

export const TerminalSelfController_fetchCatalogueVersion_v1 = {
  operationId: 'TerminalSelfController_fetchCatalogueVersion_v1',
  method: 'get',
  path: '/v1/terminals/me/catalogue/version',
  security: [{ terminalLease: [] }],
} as const satisfies OperationDescriptor<'TerminalSelfController_fetchCatalogueVersion_v1'>;
export type TerminalSelfController_fetchCatalogueVersion_v1Response =
  OperationResponse<'TerminalSelfController_fetchCatalogueVersion_v1'>;
export type TerminalSelfController_fetchCatalogueVersion_v1Body =
  OperationBody<'TerminalSelfController_fetchCatalogueVersion_v1'>;

export const TerminalSequencesController_read_v1 = {
  operationId: 'TerminalSequencesController_read_v1',
  method: 'get',
  path: '/v1/terminals/me/sequences',
  security: [{ terminalLease: [] }],
} as const satisfies OperationDescriptor<'TerminalSequencesController_read_v1'>;
export type TerminalSequencesController_read_v1Response =
  OperationResponse<'TerminalSequencesController_read_v1'>;
export type TerminalSequencesController_read_v1Body =
  OperationBody<'TerminalSequencesController_read_v1'>;

export const CatalogueItemsController_list_v1 = {
  operationId: 'CatalogueItemsController_list_v1',
  method: 'get',
  path: '/v1/catalogue/items',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueItemsController_list_v1'>;
export type CatalogueItemsController_list_v1Response =
  OperationResponse<'CatalogueItemsController_list_v1'>;
export type CatalogueItemsController_list_v1Body =
  OperationBody<'CatalogueItemsController_list_v1'>;
export type CatalogueItemsController_list_v1Query =
  OperationQuery<'CatalogueItemsController_list_v1'>;

export const CatalogueItemsController_create_v1 = {
  operationId: 'CatalogueItemsController_create_v1',
  method: 'post',
  path: '/v1/catalogue/items',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueItemsController_create_v1'>;
export type CatalogueItemsController_create_v1Response =
  OperationResponse<'CatalogueItemsController_create_v1'>;
export type CatalogueItemsController_create_v1Body =
  OperationBody<'CatalogueItemsController_create_v1'>;

export const CatalogueItemsController_read_v1 = {
  operationId: 'CatalogueItemsController_read_v1',
  method: 'get',
  path: '/v1/catalogue/items/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueItemsController_read_v1'>;
export type CatalogueItemsController_read_v1Response =
  OperationResponse<'CatalogueItemsController_read_v1'>;
export type CatalogueItemsController_read_v1Body =
  OperationBody<'CatalogueItemsController_read_v1'>;
export type CatalogueItemsController_read_v1Path =
  OperationPath<'CatalogueItemsController_read_v1'>;

export const CatalogueItemsController_retire_v1 = {
  operationId: 'CatalogueItemsController_retire_v1',
  method: 'delete',
  path: '/v1/catalogue/items/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueItemsController_retire_v1'>;
export type CatalogueItemsController_retire_v1Response =
  OperationResponse<'CatalogueItemsController_retire_v1'>;
export type CatalogueItemsController_retire_v1Body =
  OperationBody<'CatalogueItemsController_retire_v1'>;
export type CatalogueItemsController_retire_v1Path =
  OperationPath<'CatalogueItemsController_retire_v1'>;

export const CatalogueItemsController_update_v1 = {
  operationId: 'CatalogueItemsController_update_v1',
  method: 'patch',
  path: '/v1/catalogue/items/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueItemsController_update_v1'>;
export type CatalogueItemsController_update_v1Response =
  OperationResponse<'CatalogueItemsController_update_v1'>;
export type CatalogueItemsController_update_v1Body =
  OperationBody<'CatalogueItemsController_update_v1'>;
export type CatalogueItemsController_update_v1Path =
  OperationPath<'CatalogueItemsController_update_v1'>;

export const CatalogueItemsController_restore_v1 = {
  operationId: 'CatalogueItemsController_restore_v1',
  method: 'post',
  path: '/v1/catalogue/items/{id}/restore',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueItemsController_restore_v1'>;
export type CatalogueItemsController_restore_v1Response =
  OperationResponse<'CatalogueItemsController_restore_v1'>;
export type CatalogueItemsController_restore_v1Body =
  OperationBody<'CatalogueItemsController_restore_v1'>;
export type CatalogueItemsController_restore_v1Path =
  OperationPath<'CatalogueItemsController_restore_v1'>;

export const CataloguePricesController_list_v1 = {
  operationId: 'CataloguePricesController_list_v1',
  method: 'get',
  path: '/v1/catalogue/items/{id}/prices',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CataloguePricesController_list_v1'>;
export type CataloguePricesController_list_v1Response =
  OperationResponse<'CataloguePricesController_list_v1'>;
export type CataloguePricesController_list_v1Body =
  OperationBody<'CataloguePricesController_list_v1'>;
export type CataloguePricesController_list_v1Path =
  OperationPath<'CataloguePricesController_list_v1'>;
export type CataloguePricesController_list_v1Query =
  OperationQuery<'CataloguePricesController_list_v1'>;

export const CataloguePricesController_reprice_v1 = {
  operationId: 'CataloguePricesController_reprice_v1',
  method: 'post',
  path: '/v1/catalogue/items/{id}/prices',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CataloguePricesController_reprice_v1'>;
export type CataloguePricesController_reprice_v1Response =
  OperationResponse<'CataloguePricesController_reprice_v1'>;
export type CataloguePricesController_reprice_v1Body =
  OperationBody<'CataloguePricesController_reprice_v1'>;
export type CataloguePricesController_reprice_v1Path =
  OperationPath<'CataloguePricesController_reprice_v1'>;

export const CataloguePricesController_at_v1 = {
  operationId: 'CataloguePricesController_at_v1',
  method: 'get',
  path: '/v1/catalogue/items/{id}/prices/at',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CataloguePricesController_at_v1'>;
export type CataloguePricesController_at_v1Response =
  OperationResponse<'CataloguePricesController_at_v1'>;
export type CataloguePricesController_at_v1Body = OperationBody<'CataloguePricesController_at_v1'>;
export type CataloguePricesController_at_v1Path = OperationPath<'CataloguePricesController_at_v1'>;
export type CataloguePricesController_at_v1Query =
  OperationQuery<'CataloguePricesController_at_v1'>;

export const CatalogueAvailabilityController_list_v1 = {
  operationId: 'CatalogueAvailabilityController_list_v1',
  method: 'get',
  path: '/v1/catalogue/items/{id}/outlets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueAvailabilityController_list_v1'>;
export type CatalogueAvailabilityController_list_v1Response =
  OperationResponse<'CatalogueAvailabilityController_list_v1'>;
export type CatalogueAvailabilityController_list_v1Body =
  OperationBody<'CatalogueAvailabilityController_list_v1'>;
export type CatalogueAvailabilityController_list_v1Path =
  OperationPath<'CatalogueAvailabilityController_list_v1'>;
export type CatalogueAvailabilityController_list_v1Query =
  OperationQuery<'CatalogueAvailabilityController_list_v1'>;

export const CatalogueAvailabilityController_replace_v1 = {
  operationId: 'CatalogueAvailabilityController_replace_v1',
  method: 'put',
  path: '/v1/catalogue/items/{id}/outlets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CatalogueAvailabilityController_replace_v1'>;
export type CatalogueAvailabilityController_replace_v1Response =
  OperationResponse<'CatalogueAvailabilityController_replace_v1'>;
export type CatalogueAvailabilityController_replace_v1Body =
  OperationBody<'CatalogueAvailabilityController_replace_v1'>;
export type CatalogueAvailabilityController_replace_v1Path =
  OperationPath<'CatalogueAvailabilityController_replace_v1'>;

export const OutletCatalogueController_read_v1 = {
  operationId: 'OutletCatalogueController_read_v1',
  method: 'get',
  path: '/v1/outlets/{id}/catalogue',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletCatalogueController_read_v1'>;
export type OutletCatalogueController_read_v1Response =
  OperationResponse<'OutletCatalogueController_read_v1'>;
export type OutletCatalogueController_read_v1Body =
  OperationBody<'OutletCatalogueController_read_v1'>;
export type OutletCatalogueController_read_v1Path =
  OperationPath<'OutletCatalogueController_read_v1'>;
export type OutletCatalogueController_read_v1Query =
  OperationQuery<'OutletCatalogueController_read_v1'>;

export const OutletsController_list_v1 = {
  operationId: 'OutletsController_list_v1',
  method: 'get',
  path: '/v1/outlets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletsController_list_v1'>;
export type OutletsController_list_v1Response = OperationResponse<'OutletsController_list_v1'>;
export type OutletsController_list_v1Body = OperationBody<'OutletsController_list_v1'>;
export type OutletsController_list_v1Query = OperationQuery<'OutletsController_list_v1'>;

export const OutletsController_create_v1 = {
  operationId: 'OutletsController_create_v1',
  method: 'post',
  path: '/v1/outlets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletsController_create_v1'>;
export type OutletsController_create_v1Response = OperationResponse<'OutletsController_create_v1'>;
export type OutletsController_create_v1Body = OperationBody<'OutletsController_create_v1'>;

export const OutletsController_read_v1 = {
  operationId: 'OutletsController_read_v1',
  method: 'get',
  path: '/v1/outlets/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletsController_read_v1'>;
export type OutletsController_read_v1Response = OperationResponse<'OutletsController_read_v1'>;
export type OutletsController_read_v1Body = OperationBody<'OutletsController_read_v1'>;
export type OutletsController_read_v1Path = OperationPath<'OutletsController_read_v1'>;

export const OutletsController_retire_v1 = {
  operationId: 'OutletsController_retire_v1',
  method: 'delete',
  path: '/v1/outlets/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletsController_retire_v1'>;
export type OutletsController_retire_v1Response = OperationResponse<'OutletsController_retire_v1'>;
export type OutletsController_retire_v1Body = OperationBody<'OutletsController_retire_v1'>;
export type OutletsController_retire_v1Path = OperationPath<'OutletsController_retire_v1'>;

export const OutletsController_rename_v1 = {
  operationId: 'OutletsController_rename_v1',
  method: 'patch',
  path: '/v1/outlets/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletsController_rename_v1'>;
export type OutletsController_rename_v1Response = OperationResponse<'OutletsController_rename_v1'>;
export type OutletsController_rename_v1Body = OperationBody<'OutletsController_rename_v1'>;
export type OutletsController_rename_v1Path = OperationPath<'OutletsController_rename_v1'>;

export const UserAssignmentsController_list_v1 = {
  operationId: 'UserAssignmentsController_list_v1',
  method: 'get',
  path: '/v1/users/{id}/outlets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UserAssignmentsController_list_v1'>;
export type UserAssignmentsController_list_v1Response =
  OperationResponse<'UserAssignmentsController_list_v1'>;
export type UserAssignmentsController_list_v1Body =
  OperationBody<'UserAssignmentsController_list_v1'>;
export type UserAssignmentsController_list_v1Path =
  OperationPath<'UserAssignmentsController_list_v1'>;
export type UserAssignmentsController_list_v1Query =
  OperationQuery<'UserAssignmentsController_list_v1'>;

export const UserAssignmentsController_replace_v1 = {
  operationId: 'UserAssignmentsController_replace_v1',
  method: 'put',
  path: '/v1/users/{id}/outlets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UserAssignmentsController_replace_v1'>;
export type UserAssignmentsController_replace_v1Response =
  OperationResponse<'UserAssignmentsController_replace_v1'>;
export type UserAssignmentsController_replace_v1Body =
  OperationBody<'UserAssignmentsController_replace_v1'>;
export type UserAssignmentsController_replace_v1Path =
  OperationPath<'UserAssignmentsController_replace_v1'>;

export const OutletAssignmentsController_list_v1 = {
  operationId: 'OutletAssignmentsController_list_v1',
  method: 'get',
  path: '/v1/outlets/{id}/users',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletAssignmentsController_list_v1'>;
export type OutletAssignmentsController_list_v1Response =
  OperationResponse<'OutletAssignmentsController_list_v1'>;
export type OutletAssignmentsController_list_v1Body =
  OperationBody<'OutletAssignmentsController_list_v1'>;
export type OutletAssignmentsController_list_v1Path =
  OperationPath<'OutletAssignmentsController_list_v1'>;
export type OutletAssignmentsController_list_v1Query =
  OperationQuery<'OutletAssignmentsController_list_v1'>;

export const OfflineTicketRecordsController_record_v1 = {
  operationId: 'OfflineTicketRecordsController_record_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/offline-ticket-records',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OfflineTicketRecordsController_record_v1'>;
export type OfflineTicketRecordsController_record_v1Response =
  OperationResponse<'OfflineTicketRecordsController_record_v1'>;
export type OfflineTicketRecordsController_record_v1Body =
  OperationBody<'OfflineTicketRecordsController_record_v1'>;
export type OfflineTicketRecordsController_record_v1Path =
  OperationPath<'OfflineTicketRecordsController_record_v1'>;

export const TerminalTicketsController_issue_v1 = {
  operationId: 'TerminalTicketsController_issue_v1',
  method: 'post',
  path: '/v1/terminals/me/tickets',
  security: [{ terminalLease: [], actingStaff: [] }],
} as const satisfies OperationDescriptor<'TerminalTicketsController_issue_v1'>;
export type TerminalTicketsController_issue_v1Response =
  OperationResponse<'TerminalTicketsController_issue_v1'>;
export type TerminalTicketsController_issue_v1Body =
  OperationBody<'TerminalTicketsController_issue_v1'>;

export const TerminalTicketVoidsController_void_v1 = {
  operationId: 'TerminalTicketVoidsController_void_v1',
  method: 'post',
  path: '/v1/terminals/me/tickets/{id}/void',
  security: [{ terminalLease: [], actingStaff: [] }],
} as const satisfies OperationDescriptor<'TerminalTicketVoidsController_void_v1'>;
export type TerminalTicketVoidsController_void_v1Response =
  OperationResponse<'TerminalTicketVoidsController_void_v1'>;
export type TerminalTicketVoidsController_void_v1Body =
  OperationBody<'TerminalTicketVoidsController_void_v1'>;
export type TerminalTicketVoidsController_void_v1Path =
  OperationPath<'TerminalTicketVoidsController_void_v1'>;

export const TicketsController_list_v1 = {
  operationId: 'TicketsController_list_v1',
  method: 'get',
  path: '/v1/tickets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TicketsController_list_v1'>;
export type TicketsController_list_v1Response = OperationResponse<'TicketsController_list_v1'>;
export type TicketsController_list_v1Body = OperationBody<'TicketsController_list_v1'>;
export type TicketsController_list_v1Query = OperationQuery<'TicketsController_list_v1'>;

export const TicketsController_read_v1 = {
  operationId: 'TicketsController_read_v1',
  method: 'get',
  path: '/v1/tickets/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TicketsController_read_v1'>;
export type TicketsController_read_v1Response = OperationResponse<'TicketsController_read_v1'>;
export type TicketsController_read_v1Body = OperationBody<'TicketsController_read_v1'>;
export type TicketsController_read_v1Path = OperationPath<'TicketsController_read_v1'>;

export const TicketsController_readByNumber_v1 = {
  operationId: 'TicketsController_readByNumber_v1',
  method: 'get',
  path: '/v1/tickets/by-number/{number}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TicketsController_readByNumber_v1'>;
export type TicketsController_readByNumber_v1Response =
  OperationResponse<'TicketsController_readByNumber_v1'>;
export type TicketsController_readByNumber_v1Body =
  OperationBody<'TicketsController_readByNumber_v1'>;
export type TicketsController_readByNumber_v1Path =
  OperationPath<'TicketsController_readByNumber_v1'>;
export type TicketsController_readByNumber_v1Query =
  OperationQuery<'TicketsController_readByNumber_v1'>;

export const TicketVoidsController_void_v1 = {
  operationId: 'TicketVoidsController_void_v1',
  method: 'post',
  path: '/v1/tickets/{id}/void',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TicketVoidsController_void_v1'>;
export type TicketVoidsController_void_v1Response =
  OperationResponse<'TicketVoidsController_void_v1'>;
export type TicketVoidsController_void_v1Body = OperationBody<'TicketVoidsController_void_v1'>;
export type TicketVoidsController_void_v1Path = OperationPath<'TicketVoidsController_void_v1'>;

export const TerminalSalesController_record_v1 = {
  operationId: 'TerminalSalesController_record_v1',
  method: 'post',
  path: '/v1/terminals/me/sales',
  security: [{ terminalLease: [], actingStaff: [] }],
} as const satisfies OperationDescriptor<'TerminalSalesController_record_v1'>;
export type TerminalSalesController_record_v1Response =
  OperationResponse<'TerminalSalesController_record_v1'>;
export type TerminalSalesController_record_v1Body =
  OperationBody<'TerminalSalesController_record_v1'>;

export const TerminalSaleRefundsController_refund_v1 = {
  operationId: 'TerminalSaleRefundsController_refund_v1',
  method: 'post',
  path: '/v1/terminals/me/sales/{id}/refund',
  security: [{ terminalLease: [], actingStaff: [] }],
} as const satisfies OperationDescriptor<'TerminalSaleRefundsController_refund_v1'>;
export type TerminalSaleRefundsController_refund_v1Response =
  OperationResponse<'TerminalSaleRefundsController_refund_v1'>;
export type TerminalSaleRefundsController_refund_v1Body =
  OperationBody<'TerminalSaleRefundsController_refund_v1'>;
export type TerminalSaleRefundsController_refund_v1Path =
  OperationPath<'TerminalSaleRefundsController_refund_v1'>;

export const SaleRefundsController_refund_v1 = {
  operationId: 'SaleRefundsController_refund_v1',
  method: 'post',
  path: '/v1/sales/{id}/refund',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'SaleRefundsController_refund_v1'>;
export type SaleRefundsController_refund_v1Response =
  OperationResponse<'SaleRefundsController_refund_v1'>;
export type SaleRefundsController_refund_v1Body = OperationBody<'SaleRefundsController_refund_v1'>;
export type SaleRefundsController_refund_v1Path = OperationPath<'SaleRefundsController_refund_v1'>;

export const SalesController_list_v1 = {
  operationId: 'SalesController_list_v1',
  method: 'get',
  path: '/v1/sales',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'SalesController_list_v1'>;
export type SalesController_list_v1Response = OperationResponse<'SalesController_list_v1'>;
export type SalesController_list_v1Body = OperationBody<'SalesController_list_v1'>;
export type SalesController_list_v1Query = OperationQuery<'SalesController_list_v1'>;

export const SalesController_read_v1 = {
  operationId: 'SalesController_read_v1',
  method: 'get',
  path: '/v1/sales/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'SalesController_read_v1'>;
export type SalesController_read_v1Response = OperationResponse<'SalesController_read_v1'>;
export type SalesController_read_v1Body = OperationBody<'SalesController_read_v1'>;
export type SalesController_read_v1Path = OperationPath<'SalesController_read_v1'>;

export const SalesController_readByNumber_v1 = {
  operationId: 'SalesController_readByNumber_v1',
  method: 'get',
  path: '/v1/sales/by-number/{number}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'SalesController_readByNumber_v1'>;
export type SalesController_readByNumber_v1Response =
  OperationResponse<'SalesController_readByNumber_v1'>;
export type SalesController_readByNumber_v1Body = OperationBody<'SalesController_readByNumber_v1'>;
export type SalesController_readByNumber_v1Path = OperationPath<'SalesController_readByNumber_v1'>;

export const SaleReprintsController_reprint_v1 = {
  operationId: 'SaleReprintsController_reprint_v1',
  method: 'post',
  path: '/v1/sales/{id}/reprint',
  security: [{ session: [] }, { terminalLease: [], actingStaff: [] }],
} as const satisfies OperationDescriptor<'SaleReprintsController_reprint_v1'>;
export type SaleReprintsController_reprint_v1Response =
  OperationResponse<'SaleReprintsController_reprint_v1'>;
export type SaleReprintsController_reprint_v1Body =
  OperationBody<'SaleReprintsController_reprint_v1'>;
export type SaleReprintsController_reprint_v1Path =
  OperationPath<'SaleReprintsController_reprint_v1'>;

export const TaxIdentityController_list_v1 = {
  operationId: 'TaxIdentityController_list_v1',
  method: 'get',
  path: '/v1/tax-identities',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TaxIdentityController_list_v1'>;
export type TaxIdentityController_list_v1Response =
  OperationResponse<'TaxIdentityController_list_v1'>;
export type TaxIdentityController_list_v1Body = OperationBody<'TaxIdentityController_list_v1'>;

export const TaxIdentityController_replace_v1 = {
  operationId: 'TaxIdentityController_replace_v1',
  method: 'put',
  path: '/v1/tax-identities/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TaxIdentityController_replace_v1'>;
export type TaxIdentityController_replace_v1Response =
  OperationResponse<'TaxIdentityController_replace_v1'>;
export type TaxIdentityController_replace_v1Body =
  OperationBody<'TaxIdentityController_replace_v1'>;
export type TaxIdentityController_replace_v1Path =
  OperationPath<'TaxIdentityController_replace_v1'>;

export const TerminalTaxInvoiceHeaderController_read_v1 = {
  operationId: 'TerminalTaxInvoiceHeaderController_read_v1',
  method: 'get',
  path: '/v1/terminals/me/tax-invoice-header',
  security: [{ terminalLease: [] }],
} as const satisfies OperationDescriptor<'TerminalTaxInvoiceHeaderController_read_v1'>;
export type TerminalTaxInvoiceHeaderController_read_v1Response =
  OperationResponse<'TerminalTaxInvoiceHeaderController_read_v1'>;
export type TerminalTaxInvoiceHeaderController_read_v1Body =
  OperationBody<'TerminalTaxInvoiceHeaderController_read_v1'>;

export const ParkSettingsController_read_v1 = {
  operationId: 'ParkSettingsController_read_v1',
  method: 'get',
  path: '/v1/park-settings',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ParkSettingsController_read_v1'>;
export type ParkSettingsController_read_v1Response =
  OperationResponse<'ParkSettingsController_read_v1'>;
export type ParkSettingsController_read_v1Body = OperationBody<'ParkSettingsController_read_v1'>;

export const ParkSettingsController_replace_v1 = {
  operationId: 'ParkSettingsController_replace_v1',
  method: 'put',
  path: '/v1/park-settings',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ParkSettingsController_replace_v1'>;
export type ParkSettingsController_replace_v1Response =
  OperationResponse<'ParkSettingsController_replace_v1'>;
export type ParkSettingsController_replace_v1Body =
  OperationBody<'ParkSettingsController_replace_v1'>;

export const DeliveriesController_record_v1 = {
  operationId: 'DeliveriesController_record_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/stock/deliveries',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'DeliveriesController_record_v1'>;
export type DeliveriesController_record_v1Response =
  OperationResponse<'DeliveriesController_record_v1'>;
export type DeliveriesController_record_v1Body = OperationBody<'DeliveriesController_record_v1'>;
export type DeliveriesController_record_v1Path = OperationPath<'DeliveriesController_record_v1'>;

export const StockLevelsController_read_v1 = {
  operationId: 'StockLevelsController_read_v1',
  method: 'get',
  path: '/v1/outlets/{outletId}/stock',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'StockLevelsController_read_v1'>;
export type StockLevelsController_read_v1Response =
  OperationResponse<'StockLevelsController_read_v1'>;
export type StockLevelsController_read_v1Body = OperationBody<'StockLevelsController_read_v1'>;
export type StockLevelsController_read_v1Path = OperationPath<'StockLevelsController_read_v1'>;
export type StockLevelsController_read_v1Query = OperationQuery<'StockLevelsController_read_v1'>;

export const CorrectionsController_record_v1 = {
  operationId: 'CorrectionsController_record_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/stock/corrections',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CorrectionsController_record_v1'>;
export type CorrectionsController_record_v1Response =
  OperationResponse<'CorrectionsController_record_v1'>;
export type CorrectionsController_record_v1Body = OperationBody<'CorrectionsController_record_v1'>;
export type CorrectionsController_record_v1Path = OperationPath<'CorrectionsController_record_v1'>;

export const StocktakesController_record_v1 = {
  operationId: 'StocktakesController_record_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/stock/stocktakes',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'StocktakesController_record_v1'>;
export type StocktakesController_record_v1Response =
  OperationResponse<'StocktakesController_record_v1'>;
export type StocktakesController_record_v1Body = OperationBody<'StocktakesController_record_v1'>;
export type StocktakesController_record_v1Path = OperationPath<'StocktakesController_record_v1'>;

export const StockMovementsController_list_v1 = {
  operationId: 'StockMovementsController_list_v1',
  method: 'get',
  path: '/v1/outlets/{outletId}/stock/movements',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'StockMovementsController_list_v1'>;
export type StockMovementsController_list_v1Response =
  OperationResponse<'StockMovementsController_list_v1'>;
export type StockMovementsController_list_v1Body =
  OperationBody<'StockMovementsController_list_v1'>;
export type StockMovementsController_list_v1Path =
  OperationPath<'StockMovementsController_list_v1'>;
export type StockMovementsController_list_v1Query =
  OperationQuery<'StockMovementsController_list_v1'>;

export const TerminalStockController_read_v1 = {
  operationId: 'TerminalStockController_read_v1',
  method: 'get',
  path: '/v1/terminals/me/stock',
  security: [{ terminalLease: [] }],
} as const satisfies OperationDescriptor<'TerminalStockController_read_v1'>;
export type TerminalStockController_read_v1Response =
  OperationResponse<'TerminalStockController_read_v1'>;
export type TerminalStockController_read_v1Body = OperationBody<'TerminalStockController_read_v1'>;

export const BusinessDaysController_list_v1 = {
  operationId: 'BusinessDaysController_list_v1',
  method: 'get',
  path: '/v1/business-days',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BusinessDaysController_list_v1'>;
export type BusinessDaysController_list_v1Response =
  OperationResponse<'BusinessDaysController_list_v1'>;
export type BusinessDaysController_list_v1Body = OperationBody<'BusinessDaysController_list_v1'>;
export type BusinessDaysController_list_v1Query = OperationQuery<'BusinessDaysController_list_v1'>;

export const OutletBusinessDaysController_lookup_v1 = {
  operationId: 'OutletBusinessDaysController_lookup_v1',
  method: 'get',
  path: '/v1/outlets/{outletId}/business-days/{businessDate}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OutletBusinessDaysController_lookup_v1'>;
export type OutletBusinessDaysController_lookup_v1Response =
  OperationResponse<'OutletBusinessDaysController_lookup_v1'>;
export type OutletBusinessDaysController_lookup_v1Body =
  OperationBody<'OutletBusinessDaysController_lookup_v1'>;
export type OutletBusinessDaysController_lookup_v1Path =
  OperationPath<'OutletBusinessDaysController_lookup_v1'>;

export const PayoutsController_record_v1 = {
  operationId: 'PayoutsController_record_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/till-payouts',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'PayoutsController_record_v1'>;
export type PayoutsController_record_v1Response = OperationResponse<'PayoutsController_record_v1'>;
export type PayoutsController_record_v1Body = OperationBody<'PayoutsController_record_v1'>;
export type PayoutsController_record_v1Path = OperationPath<'PayoutsController_record_v1'>;

export const ReconciliationController_read_v1 = {
  operationId: 'ReconciliationController_read_v1',
  method: 'get',
  path: '/v1/outlets/{outletId}/business-days/{businessDate}/reconciliation',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ReconciliationController_read_v1'>;
export type ReconciliationController_read_v1Response =
  OperationResponse<'ReconciliationController_read_v1'>;
export type ReconciliationController_read_v1Body =
  OperationBody<'ReconciliationController_read_v1'>;
export type ReconciliationController_read_v1Path =
  OperationPath<'ReconciliationController_read_v1'>;

export const BusinessDayCloseController_closeDay_v1 = {
  operationId: 'BusinessDayCloseController_closeDay_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/business-days/{businessDate}/close',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BusinessDayCloseController_closeDay_v1'>;
export type BusinessDayCloseController_closeDay_v1Response =
  OperationResponse<'BusinessDayCloseController_closeDay_v1'>;
export type BusinessDayCloseController_closeDay_v1Body =
  OperationBody<'BusinessDayCloseController_closeDay_v1'>;
export type BusinessDayCloseController_closeDay_v1Path =
  OperationPath<'BusinessDayCloseController_closeDay_v1'>;

export const BusinessDayCloseController_reopenDay_v1 = {
  operationId: 'BusinessDayCloseController_reopenDay_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/business-days/{businessDate}/reopen',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BusinessDayCloseController_reopenDay_v1'>;
export type BusinessDayCloseController_reopenDay_v1Response =
  OperationResponse<'BusinessDayCloseController_reopenDay_v1'>;
export type BusinessDayCloseController_reopenDay_v1Body =
  OperationBody<'BusinessDayCloseController_reopenDay_v1'>;
export type BusinessDayCloseController_reopenDay_v1Path =
  OperationPath<'BusinessDayCloseController_reopenDay_v1'>;

export const ProfitAndLossController_park_v1 = {
  operationId: 'ProfitAndLossController_park_v1',
  method: 'get',
  path: '/v1/reports/profit-and-loss',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ProfitAndLossController_park_v1'>;
export type ProfitAndLossController_park_v1Response =
  OperationResponse<'ProfitAndLossController_park_v1'>;
export type ProfitAndLossController_park_v1Body = OperationBody<'ProfitAndLossController_park_v1'>;
export type ProfitAndLossController_park_v1Query =
  OperationQuery<'ProfitAndLossController_park_v1'>;

export const ProfitAndLossController_parkTradingSummary_v1 = {
  operationId: 'ProfitAndLossController_parkTradingSummary_v1',
  method: 'get',
  path: '/v1/reports/trading-summary',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ProfitAndLossController_parkTradingSummary_v1'>;
export type ProfitAndLossController_parkTradingSummary_v1Response =
  OperationResponse<'ProfitAndLossController_parkTradingSummary_v1'>;
export type ProfitAndLossController_parkTradingSummary_v1Body =
  OperationBody<'ProfitAndLossController_parkTradingSummary_v1'>;
export type ProfitAndLossController_parkTradingSummary_v1Query =
  OperationQuery<'ProfitAndLossController_parkTradingSummary_v1'>;

export const ProfitAndLossController_outlet_v1 = {
  operationId: 'ProfitAndLossController_outlet_v1',
  method: 'get',
  path: '/v1/reports/outlets/{outletId}/profit-and-loss',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ProfitAndLossController_outlet_v1'>;
export type ProfitAndLossController_outlet_v1Response =
  OperationResponse<'ProfitAndLossController_outlet_v1'>;
export type ProfitAndLossController_outlet_v1Body =
  OperationBody<'ProfitAndLossController_outlet_v1'>;
export type ProfitAndLossController_outlet_v1Path =
  OperationPath<'ProfitAndLossController_outlet_v1'>;
export type ProfitAndLossController_outlet_v1Query =
  OperationQuery<'ProfitAndLossController_outlet_v1'>;

export const ProfitAndLossController_tradingSummary_v1 = {
  operationId: 'ProfitAndLossController_tradingSummary_v1',
  method: 'get',
  path: '/v1/reports/outlets/{outletId}/trading-summary',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ProfitAndLossController_tradingSummary_v1'>;
export type ProfitAndLossController_tradingSummary_v1Response =
  OperationResponse<'ProfitAndLossController_tradingSummary_v1'>;
export type ProfitAndLossController_tradingSummary_v1Body =
  OperationBody<'ProfitAndLossController_tradingSummary_v1'>;
export type ProfitAndLossController_tradingSummary_v1Path =
  OperationPath<'ProfitAndLossController_tradingSummary_v1'>;
export type ProfitAndLossController_tradingSummary_v1Query =
  OperationQuery<'ProfitAndLossController_tradingSummary_v1'>;

export const ExpensesController_record_v1 = {
  operationId: 'ExpensesController_record_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/expenses',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExpensesController_record_v1'>;
export type ExpensesController_record_v1Response =
  OperationResponse<'ExpensesController_record_v1'>;
export type ExpensesController_record_v1Body = OperationBody<'ExpensesController_record_v1'>;
export type ExpensesController_record_v1Path = OperationPath<'ExpensesController_record_v1'>;

export const ExpensesController_list_v1 = {
  operationId: 'ExpensesController_list_v1',
  method: 'get',
  path: '/v1/expenses',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExpensesController_list_v1'>;
export type ExpensesController_list_v1Response = OperationResponse<'ExpensesController_list_v1'>;
export type ExpensesController_list_v1Body = OperationBody<'ExpensesController_list_v1'>;
export type ExpensesController_list_v1Query = OperationQuery<'ExpensesController_list_v1'>;

export const CashBookController_cashBookPage_v1 = {
  operationId: 'CashBookController_cashBookPage_v1',
  method: 'get',
  path: '/v1/reports/cash-book',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'CashBookController_cashBookPage_v1'>;
export type CashBookController_cashBookPage_v1Response =
  OperationResponse<'CashBookController_cashBookPage_v1'>;
export type CashBookController_cashBookPage_v1Body =
  OperationBody<'CashBookController_cashBookPage_v1'>;
export type CashBookController_cashBookPage_v1Query =
  OperationQuery<'CashBookController_cashBookPage_v1'>;

export const ExportController_cashBookCsv_v1 = {
  operationId: 'ExportController_cashBookCsv_v1',
  method: 'get',
  path: '/v1/reports/cash-book.csv',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExportController_cashBookCsv_v1'>;
export type ExportController_cashBookCsv_v1Response =
  OperationResponse<'ExportController_cashBookCsv_v1'>;
export type ExportController_cashBookCsv_v1Body = OperationBody<'ExportController_cashBookCsv_v1'>;
export type ExportController_cashBookCsv_v1Query =
  OperationQuery<'ExportController_cashBookCsv_v1'>;

export const ExportController_profitAndLossCsv_v1 = {
  operationId: 'ExportController_profitAndLossCsv_v1',
  method: 'get',
  path: '/v1/reports/profit-and-loss.csv',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExportController_profitAndLossCsv_v1'>;
export type ExportController_profitAndLossCsv_v1Response =
  OperationResponse<'ExportController_profitAndLossCsv_v1'>;
export type ExportController_profitAndLossCsv_v1Body =
  OperationBody<'ExportController_profitAndLossCsv_v1'>;
export type ExportController_profitAndLossCsv_v1Query =
  OperationQuery<'ExportController_profitAndLossCsv_v1'>;

export const ExportController_parkItemsCsv_v1 = {
  operationId: 'ExportController_parkItemsCsv_v1',
  method: 'get',
  path: '/v1/reports/items.csv',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExportController_parkItemsCsv_v1'>;
export type ExportController_parkItemsCsv_v1Response =
  OperationResponse<'ExportController_parkItemsCsv_v1'>;
export type ExportController_parkItemsCsv_v1Body =
  OperationBody<'ExportController_parkItemsCsv_v1'>;
export type ExportController_parkItemsCsv_v1Query =
  OperationQuery<'ExportController_parkItemsCsv_v1'>;

export const ExportController_paymentModesCsv_v1 = {
  operationId: 'ExportController_paymentModesCsv_v1',
  method: 'get',
  path: '/v1/reports/payment-modes.csv',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExportController_paymentModesCsv_v1'>;
export type ExportController_paymentModesCsv_v1Response =
  OperationResponse<'ExportController_paymentModesCsv_v1'>;
export type ExportController_paymentModesCsv_v1Body =
  OperationBody<'ExportController_paymentModesCsv_v1'>;
export type ExportController_paymentModesCsv_v1Query =
  OperationQuery<'ExportController_paymentModesCsv_v1'>;

export const AttributionController_staff_v1 = {
  operationId: 'AttributionController_staff_v1',
  method: 'get',
  path: '/v1/reports/attribution/staff',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'AttributionController_staff_v1'>;
export type AttributionController_staff_v1Response =
  OperationResponse<'AttributionController_staff_v1'>;
export type AttributionController_staff_v1Body = OperationBody<'AttributionController_staff_v1'>;
export type AttributionController_staff_v1Query = OperationQuery<'AttributionController_staff_v1'>;

export const AttributionController_terminals_v1 = {
  operationId: 'AttributionController_terminals_v1',
  method: 'get',
  path: '/v1/reports/attribution/terminals',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'AttributionController_terminals_v1'>;
export type AttributionController_terminals_v1Response =
  OperationResponse<'AttributionController_terminals_v1'>;
export type AttributionController_terminals_v1Body =
  OperationBody<'AttributionController_terminals_v1'>;
export type AttributionController_terminals_v1Query =
  OperationQuery<'AttributionController_terminals_v1'>;

export const InvestigationController_parkItems_v1 = {
  operationId: 'InvestigationController_parkItems_v1',
  method: 'get',
  path: '/v1/reports/items',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'InvestigationController_parkItems_v1'>;
export type InvestigationController_parkItems_v1Response =
  OperationResponse<'InvestigationController_parkItems_v1'>;
export type InvestigationController_parkItems_v1Body =
  OperationBody<'InvestigationController_parkItems_v1'>;
export type InvestigationController_parkItems_v1Query =
  OperationQuery<'InvestigationController_parkItems_v1'>;

export const InvestigationController_outletItems_v1 = {
  operationId: 'InvestigationController_outletItems_v1',
  method: 'get',
  path: '/v1/reports/outlets/{outletId}/items',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'InvestigationController_outletItems_v1'>;
export type InvestigationController_outletItems_v1Response =
  OperationResponse<'InvestigationController_outletItems_v1'>;
export type InvestigationController_outletItems_v1Body =
  OperationBody<'InvestigationController_outletItems_v1'>;
export type InvestigationController_outletItems_v1Path =
  OperationPath<'InvestigationController_outletItems_v1'>;
export type InvestigationController_outletItems_v1Query =
  OperationQuery<'InvestigationController_outletItems_v1'>;

export const TraceController_trace_v1 = {
  operationId: 'TraceController_trace_v1',
  method: 'get',
  path: '/v1/reports/trace',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'TraceController_trace_v1'>;
export type TraceController_trace_v1Response = OperationResponse<'TraceController_trace_v1'>;
export type TraceController_trace_v1Body = OperationBody<'TraceController_trace_v1'>;
export type TraceController_trace_v1Query = OperationQuery<'TraceController_trace_v1'>;

export const PaymentModesController_park_v1 = {
  operationId: 'PaymentModesController_park_v1',
  method: 'get',
  path: '/v1/reports/payment-modes',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'PaymentModesController_park_v1'>;
export type PaymentModesController_park_v1Response =
  OperationResponse<'PaymentModesController_park_v1'>;
export type PaymentModesController_park_v1Body = OperationBody<'PaymentModesController_park_v1'>;
export type PaymentModesController_park_v1Query = OperationQuery<'PaymentModesController_park_v1'>;

export const PaymentModesController_outlet_v1 = {
  operationId: 'PaymentModesController_outlet_v1',
  method: 'get',
  path: '/v1/reports/outlets/{outletId}/payment-modes',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'PaymentModesController_outlet_v1'>;
export type PaymentModesController_outlet_v1Response =
  OperationResponse<'PaymentModesController_outlet_v1'>;
export type PaymentModesController_outlet_v1Body =
  OperationBody<'PaymentModesController_outlet_v1'>;
export type PaymentModesController_outlet_v1Path =
  OperationPath<'PaymentModesController_outlet_v1'>;
export type PaymentModesController_outlet_v1Query =
  OperationQuery<'PaymentModesController_outlet_v1'>;

export const ItemTradingController_park_v1 = {
  operationId: 'ItemTradingController_park_v1',
  method: 'get',
  path: '/v1/reports/item-trading-summary',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ItemTradingController_park_v1'>;
export type ItemTradingController_park_v1Response =
  OperationResponse<'ItemTradingController_park_v1'>;
export type ItemTradingController_park_v1Body = OperationBody<'ItemTradingController_park_v1'>;
export type ItemTradingController_park_v1Query = OperationQuery<'ItemTradingController_park_v1'>;

export const ItemTradingController_outlet_v1 = {
  operationId: 'ItemTradingController_outlet_v1',
  method: 'get',
  path: '/v1/reports/outlets/{outletId}/item-trading-summary',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ItemTradingController_outlet_v1'>;
export type ItemTradingController_outlet_v1Response =
  OperationResponse<'ItemTradingController_outlet_v1'>;
export type ItemTradingController_outlet_v1Body = OperationBody<'ItemTradingController_outlet_v1'>;
export type ItemTradingController_outlet_v1Path = OperationPath<'ItemTradingController_outlet_v1'>;
export type ItemTradingController_outlet_v1Query =
  OperationQuery<'ItemTradingController_outlet_v1'>;

export const BillingMachinesController_list_v1 = {
  operationId: 'BillingMachinesController_list_v1',
  method: 'get',
  path: '/v1/billing-machines',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BillingMachinesController_list_v1'>;
export type BillingMachinesController_list_v1Response =
  OperationResponse<'BillingMachinesController_list_v1'>;
export type BillingMachinesController_list_v1Body =
  OperationBody<'BillingMachinesController_list_v1'>;
export type BillingMachinesController_list_v1Query =
  OperationQuery<'BillingMachinesController_list_v1'>;

export const BillingMachinesController_register_v1 = {
  operationId: 'BillingMachinesController_register_v1',
  method: 'post',
  path: '/v1/billing-machines',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BillingMachinesController_register_v1'>;
export type BillingMachinesController_register_v1Response =
  OperationResponse<'BillingMachinesController_register_v1'>;
export type BillingMachinesController_register_v1Body =
  OperationBody<'BillingMachinesController_register_v1'>;

export const BillingMachinesController_findOne_v1 = {
  operationId: 'BillingMachinesController_findOne_v1',
  method: 'get',
  path: '/v1/billing-machines/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BillingMachinesController_findOne_v1'>;
export type BillingMachinesController_findOne_v1Response =
  OperationResponse<'BillingMachinesController_findOne_v1'>;
export type BillingMachinesController_findOne_v1Body =
  OperationBody<'BillingMachinesController_findOne_v1'>;
export type BillingMachinesController_findOne_v1Path =
  OperationPath<'BillingMachinesController_findOne_v1'>;

export const BillingMachinesController_rename_v1 = {
  operationId: 'BillingMachinesController_rename_v1',
  method: 'patch',
  path: '/v1/billing-machines/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BillingMachinesController_rename_v1'>;
export type BillingMachinesController_rename_v1Response =
  OperationResponse<'BillingMachinesController_rename_v1'>;
export type BillingMachinesController_rename_v1Body =
  OperationBody<'BillingMachinesController_rename_v1'>;
export type BillingMachinesController_rename_v1Path =
  OperationPath<'BillingMachinesController_rename_v1'>;

export const BillingMachinesController_attach_v1 = {
  operationId: 'BillingMachinesController_attach_v1',
  method: 'post',
  path: '/v1/billing-machines/{id}/attachments',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'BillingMachinesController_attach_v1'>;
export type BillingMachinesController_attach_v1Response =
  OperationResponse<'BillingMachinesController_attach_v1'>;
export type BillingMachinesController_attach_v1Body =
  OperationBody<'BillingMachinesController_attach_v1'>;
export type BillingMachinesController_attach_v1Path =
  OperationPath<'BillingMachinesController_attach_v1'>;

export const ProductCodesController_map_v1 = {
  operationId: 'ProductCodesController_map_v1',
  method: 'put',
  path: '/v1/billing-machines/{id}/product-codes/{code}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ProductCodesController_map_v1'>;
export type ProductCodesController_map_v1Response =
  OperationResponse<'ProductCodesController_map_v1'>;
export type ProductCodesController_map_v1Body = OperationBody<'ProductCodesController_map_v1'>;
export type ProductCodesController_map_v1Path = OperationPath<'ProductCodesController_map_v1'>;

export const ProductCodesController_list_v1 = {
  operationId: 'ProductCodesController_list_v1',
  method: 'get',
  path: '/v1/billing-machines/{id}/product-codes',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ProductCodesController_list_v1'>;
export type ProductCodesController_list_v1Response =
  OperationResponse<'ProductCodesController_list_v1'>;
export type ProductCodesController_list_v1Body = OperationBody<'ProductCodesController_list_v1'>;
export type ProductCodesController_list_v1Path = OperationPath<'ProductCodesController_list_v1'>;
export type ProductCodesController_list_v1Query = OperationQuery<'ProductCodesController_list_v1'>;

export const MachineImportsController_list_v1 = {
  operationId: 'MachineImportsController_list_v1',
  method: 'get',
  path: '/v1/machine-imports',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'MachineImportsController_list_v1'>;
export type MachineImportsController_list_v1Response =
  OperationResponse<'MachineImportsController_list_v1'>;
export type MachineImportsController_list_v1Body =
  OperationBody<'MachineImportsController_list_v1'>;
export type MachineImportsController_list_v1Query =
  OperationQuery<'MachineImportsController_list_v1'>;

export const MachineImportsController_record_v1 = {
  operationId: 'MachineImportsController_record_v1',
  method: 'post',
  path: '/v1/machine-imports',
  security: [{ session: [] }],
  bodyMediaType: 'text/csv',
} as const satisfies OperationDescriptor<'MachineImportsController_record_v1'>;
export type MachineImportsController_record_v1Response =
  OperationResponse<'MachineImportsController_record_v1'>;
export type MachineImportsController_record_v1Body =
  OperationBody<'MachineImportsController_record_v1'>;
export type MachineImportsController_record_v1Query =
  OperationQuery<'MachineImportsController_record_v1'>;

export const MachineImportsController_preview_v1 = {
  operationId: 'MachineImportsController_preview_v1',
  method: 'post',
  path: '/v1/machine-imports/preview',
  security: [{ session: [] }],
  bodyMediaType: 'text/csv',
} as const satisfies OperationDescriptor<'MachineImportsController_preview_v1'>;
export type MachineImportsController_preview_v1Response =
  OperationResponse<'MachineImportsController_preview_v1'>;
export type MachineImportsController_preview_v1Body =
  OperationBody<'MachineImportsController_preview_v1'>;
export type MachineImportsController_preview_v1Query =
  OperationQuery<'MachineImportsController_preview_v1'>;

export const MachineImportsController_findOne_v1 = {
  operationId: 'MachineImportsController_findOne_v1',
  method: 'get',
  path: '/v1/machine-imports/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'MachineImportsController_findOne_v1'>;
export type MachineImportsController_findOne_v1Response =
  OperationResponse<'MachineImportsController_findOne_v1'>;
export type MachineImportsController_findOne_v1Body =
  OperationBody<'MachineImportsController_findOne_v1'>;
export type MachineImportsController_findOne_v1Path =
  OperationPath<'MachineImportsController_findOne_v1'>;

export const MachineImportsController_file_v1 = {
  operationId: 'MachineImportsController_file_v1',
  method: 'get',
  path: '/v1/machine-imports/{id}/file',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'MachineImportsController_file_v1'>;
export type MachineImportsController_file_v1Response =
  OperationResponse<'MachineImportsController_file_v1'>;
export type MachineImportsController_file_v1Body =
  OperationBody<'MachineImportsController_file_v1'>;
export type MachineImportsController_file_v1Path =
  OperationPath<'MachineImportsController_file_v1'>;

export const MachineBillsController_list_v1 = {
  operationId: 'MachineBillsController_list_v1',
  method: 'get',
  path: '/v1/machine-bills',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'MachineBillsController_list_v1'>;
export type MachineBillsController_list_v1Response =
  OperationResponse<'MachineBillsController_list_v1'>;
export type MachineBillsController_list_v1Body = OperationBody<'MachineBillsController_list_v1'>;
export type MachineBillsController_list_v1Query = OperationQuery<'MachineBillsController_list_v1'>;

export const MachineBillsController_findOne_v1 = {
  operationId: 'MachineBillsController_findOne_v1',
  method: 'get',
  path: '/v1/machine-bills/{saleId}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'MachineBillsController_findOne_v1'>;
export type MachineBillsController_findOne_v1Response =
  OperationResponse<'MachineBillsController_findOne_v1'>;
export type MachineBillsController_findOne_v1Body =
  OperationBody<'MachineBillsController_findOne_v1'>;
export type MachineBillsController_findOne_v1Path =
  OperationPath<'MachineBillsController_findOne_v1'>;

export const MachineBillsController_reverse_v1 = {
  operationId: 'MachineBillsController_reverse_v1',
  method: 'post',
  path: '/v1/machine-bills/{saleId}/reversal',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'MachineBillsController_reverse_v1'>;
export type MachineBillsController_reverse_v1Response =
  OperationResponse<'MachineBillsController_reverse_v1'>;
export type MachineBillsController_reverse_v1Body =
  OperationBody<'MachineBillsController_reverse_v1'>;
export type MachineBillsController_reverse_v1Path =
  OperationPath<'MachineBillsController_reverse_v1'>;

export const VendorsController_list_v1 = {
  operationId: 'VendorsController_list_v1',
  method: 'get',
  path: '/v1/vendors',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'VendorsController_list_v1'>;
export type VendorsController_list_v1Response = OperationResponse<'VendorsController_list_v1'>;
export type VendorsController_list_v1Body = OperationBody<'VendorsController_list_v1'>;
export type VendorsController_list_v1Query = OperationQuery<'VendorsController_list_v1'>;

export const VendorsController_create_v1 = {
  operationId: 'VendorsController_create_v1',
  method: 'post',
  path: '/v1/vendors',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'VendorsController_create_v1'>;
export type VendorsController_create_v1Response = OperationResponse<'VendorsController_create_v1'>;
export type VendorsController_create_v1Body = OperationBody<'VendorsController_create_v1'>;

export const VendorsController_read_v1 = {
  operationId: 'VendorsController_read_v1',
  method: 'get',
  path: '/v1/vendors/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'VendorsController_read_v1'>;
export type VendorsController_read_v1Response = OperationResponse<'VendorsController_read_v1'>;
export type VendorsController_read_v1Body = OperationBody<'VendorsController_read_v1'>;
export type VendorsController_read_v1Path = OperationPath<'VendorsController_read_v1'>;

export const VendorsController_retire_v1 = {
  operationId: 'VendorsController_retire_v1',
  method: 'delete',
  path: '/v1/vendors/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'VendorsController_retire_v1'>;
export type VendorsController_retire_v1Response = OperationResponse<'VendorsController_retire_v1'>;
export type VendorsController_retire_v1Body = OperationBody<'VendorsController_retire_v1'>;
export type VendorsController_retire_v1Path = OperationPath<'VendorsController_retire_v1'>;

export const VendorsController_update_v1 = {
  operationId: 'VendorsController_update_v1',
  method: 'patch',
  path: '/v1/vendors/{id}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'VendorsController_update_v1'>;
export type VendorsController_update_v1Response = OperationResponse<'VendorsController_update_v1'>;
export type VendorsController_update_v1Body = OperationBody<'VendorsController_update_v1'>;
export type VendorsController_update_v1Path = OperationPath<'VendorsController_update_v1'>;

export const ExpenseAttachmentsController_list_v1 = {
  operationId: 'ExpenseAttachmentsController_list_v1',
  method: 'get',
  path: '/v1/expenses/{expenseId}/attachments',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExpenseAttachmentsController_list_v1'>;
export type ExpenseAttachmentsController_list_v1Response =
  OperationResponse<'ExpenseAttachmentsController_list_v1'>;
export type ExpenseAttachmentsController_list_v1Body =
  OperationBody<'ExpenseAttachmentsController_list_v1'>;
export type ExpenseAttachmentsController_list_v1Path =
  OperationPath<'ExpenseAttachmentsController_list_v1'>;

export const ExpenseAttachmentsController_record_v1 = {
  operationId: 'ExpenseAttachmentsController_record_v1',
  method: 'post',
  path: '/v1/expenses/{expenseId}/attachments',
  security: [{ session: [] }],
  bodyMediaType: 'application/octet-stream',
} as const satisfies OperationDescriptor<'ExpenseAttachmentsController_record_v1'>;
export type ExpenseAttachmentsController_record_v1Response =
  OperationResponse<'ExpenseAttachmentsController_record_v1'>;
export type ExpenseAttachmentsController_record_v1Body =
  OperationBody<'ExpenseAttachmentsController_record_v1'>;
export type ExpenseAttachmentsController_record_v1Path =
  OperationPath<'ExpenseAttachmentsController_record_v1'>;
export type ExpenseAttachmentsController_record_v1Query =
  OperationQuery<'ExpenseAttachmentsController_record_v1'>;

export const ExpenseAttachmentsController_content_v1 = {
  operationId: 'ExpenseAttachmentsController_content_v1',
  method: 'get',
  path: '/v1/expenses/{expenseId}/attachments/{attachmentId}/content',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ExpenseAttachmentsController_content_v1'>;
export type ExpenseAttachmentsController_content_v1Response =
  OperationResponse<'ExpenseAttachmentsController_content_v1'>;
export type ExpenseAttachmentsController_content_v1Body =
  OperationBody<'ExpenseAttachmentsController_content_v1'>;
export type ExpenseAttachmentsController_content_v1Path =
  OperationPath<'ExpenseAttachmentsController_content_v1'>;

export const UpiDeclarationsController_declare_v1 = {
  operationId: 'UpiDeclarationsController_declare_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/upi-declarations',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UpiDeclarationsController_declare_v1'>;
export type UpiDeclarationsController_declare_v1Response =
  OperationResponse<'UpiDeclarationsController_declare_v1'>;
export type UpiDeclarationsController_declare_v1Body =
  OperationBody<'UpiDeclarationsController_declare_v1'>;
export type UpiDeclarationsController_declare_v1Path =
  OperationPath<'UpiDeclarationsController_declare_v1'>;

export const UpiDeclarationsController_read_v1 = {
  operationId: 'UpiDeclarationsController_read_v1',
  method: 'get',
  path: '/v1/outlets/{outletId}/upi-declarations/{businessDate}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UpiDeclarationsController_read_v1'>;
export type UpiDeclarationsController_read_v1Response =
  OperationResponse<'UpiDeclarationsController_read_v1'>;
export type UpiDeclarationsController_read_v1Body =
  OperationBody<'UpiDeclarationsController_read_v1'>;
export type UpiDeclarationsController_read_v1Path =
  OperationPath<'UpiDeclarationsController_read_v1'>;

export const UpiDeclarationsController_list_v1 = {
  operationId: 'UpiDeclarationsController_list_v1',
  method: 'get',
  path: '/v1/upi-declarations',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'UpiDeclarationsController_list_v1'>;
export type UpiDeclarationsController_list_v1Response =
  OperationResponse<'UpiDeclarationsController_list_v1'>;
export type UpiDeclarationsController_list_v1Body =
  OperationBody<'UpiDeclarationsController_list_v1'>;
export type UpiDeclarationsController_list_v1Query =
  OperationQuery<'UpiDeclarationsController_list_v1'>;

export const RevenueSharesController_listAt_v1 = {
  operationId: 'RevenueSharesController_listAt_v1',
  method: 'get',
  path: '/v1/outlets/{outletId}/revenue-shares',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'RevenueSharesController_listAt_v1'>;
export type RevenueSharesController_listAt_v1Response =
  OperationResponse<'RevenueSharesController_listAt_v1'>;
export type RevenueSharesController_listAt_v1Body =
  OperationBody<'RevenueSharesController_listAt_v1'>;
export type RevenueSharesController_listAt_v1Path =
  OperationPath<'RevenueSharesController_listAt_v1'>;
export type RevenueSharesController_listAt_v1Query =
  OperationQuery<'RevenueSharesController_listAt_v1'>;

export const RevenueSharesController_create_v1 = {
  operationId: 'RevenueSharesController_create_v1',
  method: 'post',
  path: '/v1/outlets/{outletId}/revenue-shares',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'RevenueSharesController_create_v1'>;
export type RevenueSharesController_create_v1Response =
  OperationResponse<'RevenueSharesController_create_v1'>;
export type RevenueSharesController_create_v1Body =
  OperationBody<'RevenueSharesController_create_v1'>;
export type RevenueSharesController_create_v1Path =
  OperationPath<'RevenueSharesController_create_v1'>;

export const RevenueSharesController_end_v1 = {
  operationId: 'RevenueSharesController_end_v1',
  method: 'post',
  path: '/v1/revenue-shares/{id}/end',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'RevenueSharesController_end_v1'>;
export type RevenueSharesController_end_v1Response =
  OperationResponse<'RevenueSharesController_end_v1'>;
export type RevenueSharesController_end_v1Body = OperationBody<'RevenueSharesController_end_v1'>;
export type RevenueSharesController_end_v1Path = OperationPath<'RevenueSharesController_end_v1'>;

export const RevenueSharesController_due_v1 = {
  operationId: 'RevenueSharesController_due_v1',
  method: 'get',
  path: '/v1/outlets/{outletId}/revenue-shares/due',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'RevenueSharesController_due_v1'>;
export type RevenueSharesController_due_v1Response =
  OperationResponse<'RevenueSharesController_due_v1'>;
export type RevenueSharesController_due_v1Body = OperationBody<'RevenueSharesController_due_v1'>;
export type RevenueSharesController_due_v1Path = OperationPath<'RevenueSharesController_due_v1'>;
export type RevenueSharesController_due_v1Query = OperationQuery<'RevenueSharesController_due_v1'>;

export const RevenueSharesController_inForce_v1 = {
  operationId: 'RevenueSharesController_inForce_v1',
  method: 'get',
  path: '/v1/revenue-shares',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'RevenueSharesController_inForce_v1'>;
export type RevenueSharesController_inForce_v1Response =
  OperationResponse<'RevenueSharesController_inForce_v1'>;
export type RevenueSharesController_inForce_v1Body =
  OperationBody<'RevenueSharesController_inForce_v1'>;
export type RevenueSharesController_inForce_v1Query =
  OperationQuery<'RevenueSharesController_inForce_v1'>;

export const OpeningBalancesController_record_v1 = {
  operationId: 'OpeningBalancesController_record_v1',
  method: 'post',
  path: '/v1/opening-balances',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OpeningBalancesController_record_v1'>;
export type OpeningBalancesController_record_v1Response =
  OperationResponse<'OpeningBalancesController_record_v1'>;
export type OpeningBalancesController_record_v1Body =
  OperationBody<'OpeningBalancesController_record_v1'>;

export const OpeningBalancesController_current_v1 = {
  operationId: 'OpeningBalancesController_current_v1',
  method: 'get',
  path: '/v1/opening-balances/current',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'OpeningBalancesController_current_v1'>;
export type OpeningBalancesController_current_v1Response =
  OperationResponse<'OpeningBalancesController_current_v1'>;
export type OpeningBalancesController_current_v1Body =
  OperationBody<'OpeningBalancesController_current_v1'>;

export const DailySheetLayoutController_read_v1 = {
  operationId: 'DailySheetLayoutController_read_v1',
  method: 'get',
  path: '/v1/daily-sheet-layout',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'DailySheetLayoutController_read_v1'>;
export type DailySheetLayoutController_read_v1Response =
  OperationResponse<'DailySheetLayoutController_read_v1'>;
export type DailySheetLayoutController_read_v1Body =
  OperationBody<'DailySheetLayoutController_read_v1'>;

export const DailySheetLayoutController_replace_v1 = {
  operationId: 'DailySheetLayoutController_replace_v1',
  method: 'put',
  path: '/v1/daily-sheet-layout',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'DailySheetLayoutController_replace_v1'>;
export type DailySheetLayoutController_replace_v1Response =
  OperationResponse<'DailySheetLayoutController_replace_v1'>;
export type DailySheetLayoutController_replace_v1Body =
  OperationBody<'DailySheetLayoutController_replace_v1'>;

export const ParkExpensesController_record_v1 = {
  operationId: 'ParkExpensesController_record_v1',
  method: 'post',
  path: '/v1/park-expenses',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'ParkExpensesController_record_v1'>;
export type ParkExpensesController_record_v1Response =
  OperationResponse<'ParkExpensesController_record_v1'>;
export type ParkExpensesController_record_v1Body =
  OperationBody<'ParkExpensesController_record_v1'>;

export const DailySheetController_day_v1 = {
  operationId: 'DailySheetController_day_v1',
  method: 'get',
  path: '/v1/daily-sheets/{businessDate}',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'DailySheetController_day_v1'>;
export type DailySheetController_day_v1Response = OperationResponse<'DailySheetController_day_v1'>;
export type DailySheetController_day_v1Body = OperationBody<'DailySheetController_day_v1'>;
export type DailySheetController_day_v1Path = OperationPath<'DailySheetController_day_v1'>;

export const DailySheetController_page_v1 = {
  operationId: 'DailySheetController_page_v1',
  method: 'get',
  path: '/v1/daily-sheets',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'DailySheetController_page_v1'>;
export type DailySheetController_page_v1Response =
  OperationResponse<'DailySheetController_page_v1'>;
export type DailySheetController_page_v1Body = OperationBody<'DailySheetController_page_v1'>;
export type DailySheetController_page_v1Query = OperationQuery<'DailySheetController_page_v1'>;

export const DailySheetController_export_v1 = {
  operationId: 'DailySheetController_export_v1',
  method: 'get',
  path: '/v1/reports/daily-sheet.xlsx',
  security: [{ session: [] }],
} as const satisfies OperationDescriptor<'DailySheetController_export_v1'>;
export type DailySheetController_export_v1Response =
  OperationResponse<'DailySheetController_export_v1'>;
export type DailySheetController_export_v1Body = OperationBody<'DailySheetController_export_v1'>;
export type DailySheetController_export_v1Query = OperationQuery<'DailySheetController_export_v1'>;

export const operationsById = {
  AppController_getHello_v1,
  HealthController_check_v1,
  AuthController_signIn_v1,
  AuthController_signOut_v1,
  UsersController_list_v1,
  UsersController_create_v1,
  UsersController_findOne_v1,
  UsersController_update_v1,
  UsersController_deactivate_v1,
  UsersController_reactivate_v1,
  UsersController_clearLockout_v1,
  UsersController_changeOwn_v1,
  TerminalsController_list_v1,
  TerminalsController_create_v1,
  TerminalsController_register_v1,
  TerminalsController_revoke_v1,
  TerminalSelfController_renewLease_v1,
  TerminalSelfController_fetchRoster_v1,
  TerminalSelfController_fetchCatalogue_v1,
  TerminalSelfController_fetchCatalogueVersion_v1,
  TerminalSequencesController_read_v1,
  CatalogueItemsController_list_v1,
  CatalogueItemsController_create_v1,
  CatalogueItemsController_read_v1,
  CatalogueItemsController_retire_v1,
  CatalogueItemsController_update_v1,
  CatalogueItemsController_restore_v1,
  CataloguePricesController_list_v1,
  CataloguePricesController_reprice_v1,
  CataloguePricesController_at_v1,
  CatalogueAvailabilityController_list_v1,
  CatalogueAvailabilityController_replace_v1,
  OutletCatalogueController_read_v1,
  OutletsController_list_v1,
  OutletsController_create_v1,
  OutletsController_read_v1,
  OutletsController_retire_v1,
  OutletsController_rename_v1,
  UserAssignmentsController_list_v1,
  UserAssignmentsController_replace_v1,
  OutletAssignmentsController_list_v1,
  OfflineTicketRecordsController_record_v1,
  TerminalTicketsController_issue_v1,
  TerminalTicketVoidsController_void_v1,
  TicketsController_list_v1,
  TicketsController_read_v1,
  TicketsController_readByNumber_v1,
  TicketVoidsController_void_v1,
  TerminalSalesController_record_v1,
  TerminalSaleRefundsController_refund_v1,
  SaleRefundsController_refund_v1,
  SalesController_list_v1,
  SalesController_read_v1,
  SalesController_readByNumber_v1,
  SaleReprintsController_reprint_v1,
  TaxIdentityController_list_v1,
  TaxIdentityController_replace_v1,
  TerminalTaxInvoiceHeaderController_read_v1,
  ParkSettingsController_read_v1,
  ParkSettingsController_replace_v1,
  DeliveriesController_record_v1,
  StockLevelsController_read_v1,
  CorrectionsController_record_v1,
  StocktakesController_record_v1,
  StockMovementsController_list_v1,
  TerminalStockController_read_v1,
  BusinessDaysController_list_v1,
  OutletBusinessDaysController_lookup_v1,
  PayoutsController_record_v1,
  ReconciliationController_read_v1,
  BusinessDayCloseController_closeDay_v1,
  BusinessDayCloseController_reopenDay_v1,
  ProfitAndLossController_park_v1,
  ProfitAndLossController_parkTradingSummary_v1,
  ProfitAndLossController_outlet_v1,
  ProfitAndLossController_tradingSummary_v1,
  ExpensesController_record_v1,
  ExpensesController_list_v1,
  CashBookController_cashBookPage_v1,
  ExportController_cashBookCsv_v1,
  ExportController_profitAndLossCsv_v1,
  ExportController_parkItemsCsv_v1,
  ExportController_paymentModesCsv_v1,
  AttributionController_staff_v1,
  AttributionController_terminals_v1,
  InvestigationController_parkItems_v1,
  InvestigationController_outletItems_v1,
  TraceController_trace_v1,
  PaymentModesController_park_v1,
  PaymentModesController_outlet_v1,
  ItemTradingController_park_v1,
  ItemTradingController_outlet_v1,
  BillingMachinesController_list_v1,
  BillingMachinesController_register_v1,
  BillingMachinesController_findOne_v1,
  BillingMachinesController_rename_v1,
  BillingMachinesController_attach_v1,
  ProductCodesController_map_v1,
  ProductCodesController_list_v1,
  MachineImportsController_list_v1,
  MachineImportsController_record_v1,
  MachineImportsController_preview_v1,
  MachineImportsController_findOne_v1,
  MachineImportsController_file_v1,
  MachineBillsController_list_v1,
  MachineBillsController_findOne_v1,
  MachineBillsController_reverse_v1,
  VendorsController_list_v1,
  VendorsController_create_v1,
  VendorsController_read_v1,
  VendorsController_retire_v1,
  VendorsController_update_v1,
  ExpenseAttachmentsController_list_v1,
  ExpenseAttachmentsController_record_v1,
  ExpenseAttachmentsController_content_v1,
  UpiDeclarationsController_declare_v1,
  UpiDeclarationsController_read_v1,
  UpiDeclarationsController_list_v1,
  RevenueSharesController_listAt_v1,
  RevenueSharesController_create_v1,
  RevenueSharesController_end_v1,
  RevenueSharesController_due_v1,
  RevenueSharesController_inForce_v1,
  OpeningBalancesController_record_v1,
  OpeningBalancesController_current_v1,
  DailySheetLayoutController_read_v1,
  DailySheetLayoutController_replace_v1,
  ParkExpensesController_record_v1,
  DailySheetController_day_v1,
  DailySheetController_page_v1,
  DailySheetController_export_v1,
} as const;
